import { Box  , Modal} from '@mui/material'
import React , {useState} from 'react'

import AlertOnAmount from '../AlertTypes/AlertOnAmount';
import AlertOnText from '../AlertTypes/AlertOnText';
import {  useDispatch } from 'react-redux';
import ModalAlerts from '../../shared/DeleteModal';
import {deleteCriteria, getInternalAlerts} from '../state/alertActions'
const CriteriaForms = ({current ,formik , Templates , messageTypes ,Currency , touched , setTouched  ,success , error }) => {

 


const dispatch = useDispatch()
    const [anchorEl, setAnchorEl] = useState(null);
   const [CriteriaGroup,setCritrtiaGroup]= useState(null)
   const [openDeleteModal,setOpenDeleteModal] = useState(false)
    const handleClick = (e) => {
      
      setAnchorEl(e.currentTarget);
      e.stopPropagation();
    };
  
    const handleClose = () => {
      setAnchorEl(null);
    };


    const handleDelete = (id) => {
      setCritrtiaGroup(id)
      setOpenDeleteModal(true)
    }
    
    const AlertMenu = [
      {
        id: 1,
        action: "Delete",
        handler: handleDelete,
      },
    ];


    const  handleDeleteAction = () => {

      dispatch(deleteCriteria(CriteriaGroup, success, error)).then(() => {
        dispatch(getInternalAlerts(false))
        setOpenDeleteModal(false)
        setCritrtiaGroup(null)
      });
      
      }


  return (
    <>
<Modal
  open={openDeleteModal}
  handleClose={() => setOpenDeleteModal(false)}
>
<ModalAlerts
 title="Permenantly Delete Template"
 btnTitle="Delete Criteria"
 content={
  "Are you sure you want to delete Criteria? data will no longer be restored."
}
handleCloseModal={() => setOpenDeleteModal(false)}
action={handleDeleteAction}
/>
</Modal>



    <Box
    sx={{
        backgroundColor:"#fff",
        marginBottom:"15px !important",
        boxShadow: "0 1px 2px 1px rgba(0,0,0,0.06)",
        borderRadius:"8px",
        padding:"20px"
    }}
    >


{current.alertType === "AMOUNT" &&
 <AlertOnAmount 
 Templates={Templates} 
 messageTypes={messageTypes} 
 Currency={Currency}
  formik={formik}
  touched={touched}
  setTouched={setTouched} 
  handleClick={handleClick}
  handleClose={handleClose}
  anchorEl={anchorEl}
menu={AlertMenu}
  />
  }
{current.alertType === "TEXT" && 
<AlertOnText
 current={current}
Templates={Templates} 
messageTypes={messageTypes} 
Currency={Currency}
 formik={formik}
 touched={touched}
 setTouched={setTouched} 
 handleClick={handleClick}
 handleClose={handleClose}
 anchorEl={anchorEl}
menu={AlertMenu}
/>}
 

    </Box>
    
    
    </>
  )
}

export default React.memo(CriteriaForms)